import { useRef, useEffect } from 'react';

type TProps = {
	scrollbarColor?: string;
	width?: number;
	thumbRadius?: number;
	thumbColor?: string;
	thumbMargin?: string;
}

export const Scrollbar = (props: TProps) => {
	const {
		scrollbarColor = '#F2F2F2',
		width = 4,
		thumbRadius = 10,
		thumbColor = '#E8E5E5',
		thumbMargin = 0
	} = props;
	const divRef = useRef<HTMLDivElement>(null);
	useEffect(() => {
		if (divRef && divRef.current) {
			const parent = divRef.current.parentElement;
			if (parent) {
				parent.classList.add('scrollbar');
			}
		}
	}, [divRef, divRef.current]);
	return <>
		<style>
			{`
				.scrollbar::-webkit-scrollbar {
					width: ${width}px;
					background: ${scrollbarColor};
				}
				.scrollbar::-webkit-scrollbar-thumb {
					border-radius: ${thumbRadius}px;
					box-shadow: inset 0 0 ${width}px ${width}px ${thumbColor};
					border: ${thumbMargin}px solid transparent;
					cursor: pointer;
				}
			`}
		</style>
		<div ref={divRef} />
	</>;
}
